import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import Analytics from '@aws-amplify/analytics';
export default (function (_ref) {
  var api = _ref.api,
      cognito = _ref.cognito;
  Analytics.disable(); // https://github.com/aws-amplify/amplify-js/issues/3484#issuecomment-505400743

  Amplify.configure({
    Auth: {
      authenticationFlowType: 'USER_SRP_AUTH',
      mandatorySignIn: true,
      region: cognito.region,
      userPoolId: cognito.userPoolId,
      userPoolWebClientId: cognito.userPoolWebClientId
    },
    API: {
      endpoints: [{
        name: 'default',
        endpoint: api.url,
        custom_header: function () {
          var _custom_header = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.t0 = "Bearer ";
                    _context.next = 3;
                    return Auth.currentSession();

                  case 3:
                    _context.t1 = _context.sent.getIdToken().getJwtToken();
                    _context.t2 = _context.t0.concat.call(_context.t0, _context.t1);
                    return _context.abrupt("return", {
                      Authorization: _context.t2
                    });

                  case 6:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function custom_header() {
            return _custom_header.apply(this, arguments);
          }

          return custom_header;
        }()
      }]
    }
  });
});